import { Dispatch, SetStateAction, useEffect, useState } from "react";

const LocalStorageLanguageKey = "language";

export default function useLanguage(): [
  string | null,
  Dispatch<SetStateAction<string | null>>,
] {
  const [language, setLanguage] = useState(() =>
    localStorage.getItem(LocalStorageLanguageKey),
  );

  useEffect(() => {
    if (language) {
      localStorage.setItem(LocalStorageLanguageKey, language);
    }
  }, [language]);

  return [language, setLanguage];
}
